import TableText from "@/components/table/TableText";
import { chineseNewYear } from "@/method/data";
import request from "@/method/request";
import { Button, message, Row, Select, Spin, Table } from 'antd';
import FileSaver from "file-saver";
import moment from 'moment';
import React, { Component } from 'react';
import getJson from "../../../../../method";
import imgSave from "../../../saveImg";
import "./index.scss";

const { Option } = Select

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            area: "1",
        }
    }


    componentDidMount() {
        this.getData({ area: this.state.area });
    }

    setChart = (data, lastData) => {
        this.setState({ data, lastData });
    }


    getData = async ({ area }) => {
        try {
            const year = moment().format('YYYY');
            let month = chineseNewYear[moment().format('Y')].m;
            let lastmonth = chineseNewYear[moment().subtract(1, 'year').format('Y')].m;
            if (area == 2) { month = 5; lastmonth = 5; }
            if (area == 3) { month = 10; lastmonth = 10 }
            const res = await request(`/_4_2_daily/holidays?year=${year}&month=${month}&lastmonth=${lastmonth}`);
            let index = 0;
            let lastIndex = 0;
            if (area == 1) {
                // 春节
                index = chineseNewYear[moment().format('Y')].d - 1;
                lastIndex = chineseNewYear[moment().subtract(1, 'year').format('Y')].d - 1;
            }
            let data = res.data.map(x => {
                return {
                    name: x.name,
                    ...new Array(14).fill(1).reduce((a, b, i) => {
                        const _data = i % 2 == 1 ? x.data : x.lastdata;
                        const _index = (i % 2 == 1 ? index : lastIndex) + Math.floor(i / 2);

                        a[`%${i + 1}`] = getJson([_index, 'occ'], _data);
                        a[`ADR${i + 1}`] = getJson([_index, 'adr'], _data);
                        return a
                    }, {})
                }
            });
            this.setState({ loading: false, data });
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }


    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table4_2_2', 1.5, '4.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const tableName = `4.2.2 节日汇总表 ${{ 1: "春节", 2: '五一', 3: "十一" }[this.state.area]}`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table4_2_2_export').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${tableName}.xls`);
        this.setState({ print: false });
    }
    render() {
        const { print, loading, data, area } = this.state;

        const year = moment().format('YYYY');
        let month = chineseNewYear[moment().format('Y')].m;
        let lastMonth = chineseNewYear[moment().subtract(1, 'year').format('Y')].m;
        if (area == 2) month = lastMonth = 5;
        if (area == 3) month = lastMonth = 10;
        const date = `${year}-${month}`;
        const lastDate = `${year - 1}-${lastMonth}`;
        let index = 0;
        let lastIndex = 0;
        if (area == 1) {
            // 春节
            index = chineseNewYear[moment(date).format('Y')].d - 1;
            lastIndex = chineseNewYear[moment(date).subtract(1, 'year').format('Y')].d - 1;
        }

        const columns = [{
            title: 'Hotel',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 150,
            fixed: !print && 'left',
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", };
                return <TableText data={props} />
            }
        }, ...new Array(14).fill(1).map((x, i) => {
            let day = '';
            if ((Math.floor(i / 2) + 1 + (i % 2 == 1 ? index : lastIndex)) > 31) day = '-';
            return {
                title: (i % 2 == 1 ? date : lastDate) + `-${day || (Math.floor(i / 2) + 1 + (i % 2 == 1 ? index : lastIndex))}`,
                children: [{
                    title: '%',
                    dataIndex: `%${i + 1}`,
                    key: `%${i + 1}`,
                    align: "center",
                    width: 100,
                    render: (text = 0, record) => {
                        // const _data = i % 2 == 1 ? record.data : record.lastdata;
                        // const _index = i % 2 == 1 ? index : lastIndex;
                        // const value = day ? 0 : getJson([_index, 'occ'], _data);
                        const props = { text, index, type: 'percent', name: "ava", };
                        return <TableText data={props} />
                    }
                }, {
                    title: 'ADR',
                    dataIndex: `ADR${i + 1}`,
                    key: `ADR${i + 1}`,
                    align: "center",
                    width: 100,
                    render: (text = 0, record, index) => {
                        // const _data = i % 2 == 1 ? record.data : record.lastdata;
                        // const _index = i % 2 == 1 ? index : lastIndex;
                        // const value = day ? 0 : getJson([_index, 'adr'], _data);
                        const props = { text, index, type: 'number', name: "ava", };
                        return <TableText data={props} />
                    }
                }]
            }
        })];

        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6 table4_2_summary" id="table4_2_2" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>4.2.2 节日汇总表</Row>
                        <div className="title-select">
                            <Select
                                allowClear
                                defaultValue={area}
                                style={{ width: 200 }}
                                onChange={(value) => {
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        area: value
                                    }, () => {
                                        this.getData({ date, area: value })
                                    });
                                }}
                            >
                                <Option value="1">春节</Option>
                                <Option value="2">五一</Option>
                                <Option value="3">十一</Option>
                            </Select>
                        </div>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table4_2_2_export"
                            pagination={false}
                            className="content"
                            scroll={print ? {} : { y: 500, x: 2950 }}
                            rowKey={(record, index) => record.name}
                        />
                        <Button
                            type="primary"
                            style={{ float: 'right', marginTop: 20 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={print}
                        >导出Excel</Button>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/holidaySummary/index.js